import { render, staticRenderFns } from "./Upsert.vue?vue&type=template&id=60393b7e"
import script from "./Upsert.vue?vue&type=script&lang=js"
export * from "./Upsert.vue?vue&type=script&lang=js"
import style0 from "./Upsert.vue?vue&type=style&index=0&id=60393b7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports